import {catOpts, optEmptyString, orElse, pipe} from 'ts-opt';

import {Principal} from 'api/gen/Principal';

/**
 * Builds the display name for the current user.
 *
 * @param user Principal user data.
 * @returns Full name when available, otherwise the username.
 *
 * @example
 * getUserFullName(user);
 */
export const getUserFullName = (user: Principal): string => pipe(
    catOpts([optEmptyString(user.firstName), optEmptyString(user.lastName)]).join(' '),
    optEmptyString,
    orElse(user.username),
);
